<template>
  <div class="org-modal-main" @click.stop="close" v-if="show">
    <div class="org-modal-contaier" @click.stop="">
      <div class="org-content" v-if="orgs && orgs.length">
        <div class="org-modal"
        v-for="item of orgs"
        :key="item.id"
        :class="selected.indexOf(item) !== -1 ? 'active' : ''"
        @click.stop="injectOrg(item)"
        >
          {{item.name}}
        </div>
      </div>
      <div class="org-content" v-if="ins && ins.length">
        <div class="org-modal"
        v-for="item of ins"
        :key="item.id"
        :class="selected.indexOf(item) !== -1 ? 'active' : ''"
        @click.stop="injectOrg(item)"
        >
          {{item.name}}
        </div>
      </div>
      <div class="org-footer">
        <button class="sure-btn" @click.stop="change">确定</button>
        <button class="btn-cancel" @click.stop="close">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orgs: {
      type: Array,
      default: () => {}
    },
    ins: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      show: false,
      selected: []
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        this.show = val
      }
    }
  },
  methods: {
    close () {
      this.show = false
      this.$emit('input', this.show)
    },
    injectOrg (item) {
      const count = this.selected.findIndex(element => element.id === item.id)
      if (count !== -1) {
        this.selected.splice(count, 1)
      } else {
        this.selected.push(item)
      }
    },
    change () {
      if (this.selected.length) {
        const list = []
        this.selected.forEach(item => {
          list.push(item.id)
        })
        this.$emit('change', list, this.selected)
        this.close()
      } else {
        this.close(0)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.org-modal-main
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0,0,0,0.5)
  height 100vh
  overflow auto
  display flex
  justify-content center
  align-items center
  z-index 1000
  .org-modal-contaier
    background #fff
    border-radius 0.1rem
    padding 0.24rem
    display flex
    flex-direction column
    width 10rem
    height 10rem
    overflow hidden
    .org-content
      flex auto
      overflow-y scroll
      display flex
      flex-wrap wrap
      align-items center
      align-content flex-start
      justify-content space-between
      .org-modal
        width 2rem
        height 0.5rem
        border 1px solid #dcdee2
        border-radius 0.1rem
        background #f8f8f9
        text-align center
        color #333
        line-height 0.5rem
        margin 0.06rem
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .active
        background #2b85e4
        color #fff
    .org-footer
      flex-shrink 0
      height 0.5rem
      display flex
      align-items center
      button
        padding 10px 40px
        margin-top 0.2rem
        border-radius 0.1rem
        outline none
      .sure-btn
        background #2d8cf0
        color #fff
      .btn-cancel
        margin-left 0.2rem
        background #fff
        border 1px solid #dcdee2
</style>
